import { render, staticRenderFns } from "./HeatMapInfo.vue?vue&type=template&id=2ecdf074"
import script from "./HeatMapInfo.vue?vue&type=script&lang=js"
export * from "./HeatMapInfo.vue?vue&type=script&lang=js"
import style0 from "./HeatMapInfo.vue?vue&type=style&index=0&id=2ecdf074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports